module.exports = __webpack_public_path__ + "static/media/primary-3.ec90f411.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary-3.jpg
// module id = 153
// module chunks = 0